import { create } from 'zustand';

import type { UploadHealthSnapshot } from '../types/uploads';

interface UploadHealthStoreState {
  bySessionId: Readonly<Record<string, UploadHealthSnapshot>>;
}

export const useUploadHealthStore = create<UploadHealthStoreState>()(() => ({
  bySessionId: {},
}));

export const uploadHealthActions = {
  replace: (bySessionId: Readonly<Record<string, UploadHealthSnapshot>>): void => {
    useUploadHealthStore.setState({ bySessionId: { ...bySessionId } });
  },
  clear: (): void => {
    useUploadHealthStore.setState({ bySessionId: {} });
  },
};
